export default {
  '_b._qhyy': 'Mudar idioma',

  '_a._jzz': 'Carregando...',
  '_a._jzgd': 'Carregar mais',
  '_a._wct': 'Bem-vindo a',
  '_a._gd': 'Mais',
  '_a._bf': 'Reproduzir',
  '_a._bcz': 'Salvando...',
  '_a._sctp': 'Carregar imagem',

  '_dl._qssyx': 'Por favor insira seu email',
  '_dl._qssmm': 'Por favor insira sua senha',
  '_dl._ann': 'Entrar',
  '_dl._hmyzh': 'Não tem uma conta?',
  '_dl._qzc': 'Registrar',
  '_dl._yzhl': 'Já tem uma conta?',
  '_dl._qdl': 'Fazer login',
  '_dl._srqrmm': 'Por favor confirme sua senha',
  '_dl._sryqm': 'Por favor insira o código de convite',
  '_dl._sryzm': 'Por favor insira o código de verificação',
  '_dl._ljzc': 'Registrar agora',
  '_dl._zcbsty': 'O registro significa que você leu e concorda com a',
  '_dl._yszc': 'Política de Privacidade',
  '_dl._lcmmbyy': 'As senhas não coincidem',

  '_yzm._fsyzm': 'Enviar código de verificação',
  '_yzm._cxfs': '({time}) Reenviar',
  '_yzm._fsz': 'Enviando...',
  '_yzm._fscg': 'Enviado com sucesso',

  '_h._zrm': 'Mais popular',
  '_h._zxd': 'Mais recente',
  '_h._phb': 'Ranking',
  '_h._qz': 'Papéis de parede',
  '_h._ssww': 'Pesquisar',
  '_h._lsjl': 'Histórico',
  '_h._gd': 'Mais',
  '_h._dl': 'Entrar',
  '_h._ye': 'Saldo',
  '_h._dj': 'Congelado',
  '_h._ybp': 'Painel',
  '_h._wdqb': 'Minha carteira',
  '_h._scjl': 'Favoritos',
  '_h._xxzx': 'Central de mensagens',
  '_h._fxhy': 'Compartilhar com amigos',
  '_h._bzzx': 'Central de ajuda',
  '_h._ggtf': 'Colocação de anúncios',
  '_h._bqtz': 'Investimento em direitos autorais',
  '_h._sz': 'Configurações',

  '_sy._jx': 'Destacados',
  '_sy._xpfb': 'Novos lançamentos',
  '_sy._gdsp': 'Mais vídeos',

  '_qz._jbqz': 'Coleção de papéis de parede requintados',
  '_qz._ssqz': 'Pesquisar papel de parede',
  '_qz._qb': 'Todos',
  '_qz._zrfg': 'Paisagens naturais',
  '_qz._cxys': 'Arte abstrata',
  '_qz._csjz': 'Arquitetura urbana',
  '_qz._dmyx': 'Anime e jogos',
  '_qz._yzxk': 'Cosmos e estrelas',
  '_qz._yl': 'Visualizar',
  '_qz._xzqz': 'Baixar papel de parede',
  '_qz._fbl': 'Resolução',
  '_qz._fl': 'Categoria',
  '_qz._jzz': 'Carregando',
  '_qz._myzdpp': 'Nenhum papel de parede correspondente encontrado',

  '_sp._xyjscl': 'Requer desbloqueio para assistir',
  '_sp._cz': 'Recarregar',
  '_sp._jsqj': 'Desbloquear todos os episódios',
  '_sp._jsbj': 'Desbloquear este episódio',
  '_sp._sc': 'Favorito',
  '_sp._fx': 'Compartilhar',
  '_sp._jsqjjs': 'Confirmar pagamento de {a} para desbloquear todos os episódios?',
  '_sp._jsbjjs': 'Confirmar pagamento de {a} para desbloquear este episódio?',
  '_sp._zfz': 'Processando pagamento...',
  '_sp._qrzf': 'Confirmar pagamento',
  '_sp._qx': 'Cancelar',

  '_qz._smrc': 'Nascer do sol montanhês',
  '_qz._cxjh': 'Geometria abstrata',
  '_qz._dsyj': 'Paisagem noturna urbana',
  '_qz._dmfj': 'Paisagem de anime',
  '_qz._hhxk': 'Céu estrelado vasto',
  '_qz._slmw': 'Nevoa florestal',
  '_qz._scld': 'Fluxo de cores',
  '_qz._xdjz': 'Arquitetura moderna',

  '_qb._cbjl': 'Histórico de depósitos',
  '_qb._jyjl': 'Histórico de transações',
  '_qb._bddz': 'Endereços vinculados',
  '_qb._txjl': 'Histórico de saques',

  '_m._tcdl': 'Sair',
  '_m._cb': 'Depositar',
  '_m._tb': 'Sacar',

  '_cb._ssdz': 'Pesquisar moeda ou endereço',
  '_cb._bz': 'Moeda',
  '_cb._je': 'Valor',
  '_cb._dz': 'Endereço',
  '_cb._sj': 'Tempo',
  '_cb._cz': 'Ação',
  '_cb._zwjl': 'Nenhum registro de transação ainda',
  '_cb._dny': 'Página {a} de {b}',
  '_cb._jyxq': 'Detalhes da transação',
  '_cb._jydz': 'Endereço da transação',
  '_cb._zt': 'Status',
  '_cb._yqr': 'Confirmado',
  '_cb._qb': 'Todos',
  '_cb._jt': 'Hoje',
  '_cb._j7t': 'Últimos 7 dias',
  '_cb._j30t': 'Últimos 30 dias',
  '_cb._zw': 'Nenhum',
  '_cb._fzcg': 'Endereço copiado para a área de transferência',

  '_jyjl._ssdz': 'Pesquisar moeda ou endereço',
  '_jyjl._lx': 'Tipo',
  '_jyjl._je': 'Valor',
  '_jyjl._ye': 'Saldo',
  '_jyjl._dj': 'Congelado',
  '_jyjl._sj': 'Tempo',
  '_jyjl._cz': 'Ação',
  '_jyjl._zwjyjl': 'Nenhum registro de transação ainda',
  '_jyjl._czsx': 'Redefinir filtro',
  '_jyjl._dny': 'Página {a} de {b}',
  '_jyjl._jyxq': 'Detalhes da transação',
  '_jyjl._jylx': 'Tipo de transação',
  '_jyjl._jyje': 'Valor da transação',
  '_jyjl._jyhye': 'Saldo após transação',
  '_jyjl._djye': 'Valor congelado',
  '_jyjl._jysj': 'Hora da transação',
  '_jyjl._jyzt': 'Status da transação',
  '_jyjl._ywc': 'Concluído',
  '_jyjl._qb': 'Todos',
  '_jyjl._jt': 'Hoje',
  '_jyjl._j7t': 'Últimos 7 dias',
  '_jyjl._j30t': 'Últimos 30 dias',

  '_jyjl._tp1': 'Depósito',
  '_jyjl._tp2': 'Saque',
  '_jyjl._tp3': 'Pagamento',
  '_jyjl._tp4': 'Depósito',
  '_jyjl._tp5': 'Congelar',
  '_jyjl._tp6': 'Ganhos',
  '_jyjl._tp7': 'Recompensa por indicação',
  '_jyjl._tp8': 'Recompensa por login',
  '_jyjl._tp9': 'Ganhos de promoção',
  '_jyjl._tp10': 'Recompensa por vídeo',
  '_jyjl._tp11': 'Bônus de registro',
  '_jyjl._tp12': 'Retirada rejeitada',
  '_jyjl._tp13': 'Pacote Vermelho de Mensagem',

  '_jyjl._tp14': 'Transferência Interna',

  '_cb._shz': 'Em revisão',
  '_cb._yyg': 'Aprovado',
  '_cb._ybh': 'Rejeitado',

  '_bddz._tjdz': 'Adicionar endereço',
  '_bddz._ssdz': 'Pesquisar endereço',
  '_bddz._bz': 'Moeda',
  '_bddz._dz': 'Endereço',
  '_bddz._sysj': 'Último uso',
  '_bddz._cz': 'Ação',
  '_bddz._zwjl': 'Nenhum endereço ainda',
  '_bddz._dny': 'Página {a} de {b}',
  '_bddz._dzewm': 'Código QR do endereço',
  '_bddz._fzdz': 'Copiar endereço',
  '_bddz._dzxq': 'Detalhes do endereço',
  '_bddz._wl': 'Rede',
  '_bddz._tjsj': 'Data de adição',
  '_bddz._bzwa': 'Nota',
  '_bddz._ntq': '{a} dias atrás',
  '_bddz._nxsq': '{a} horas atrás',
  '_bddz._nfzq': '{a} minutos atrás',
  '_bddz._ngg': 'Agora mesmo',
  '_bddz._dzyfz': 'Endereço copiado para a área de transferência',
  '_bddz._scqr': 'Confirmação de exclusão',
  '_bddz._scqrdz': 'Tem certeza que deseja excluir este endereço?',
  '_bddz._qr': 'Confirmar',
  '_bddz._qx': 'Cancelar',
  '_bddz._scdzcg': 'Endereço excluído com sucesso',

  '_txjl._ztsx': 'Filtro por status',
  '_txjl._qbzt': 'Todos os status',
  '_txjl._shz': 'Em revisão',
  '_txjl._ytg': 'Aprovado',
  '_txjl._yjj': 'Rejeitado',
  '_txjl._ssdz': 'Pesquisar endereço ou valor',
  '_txjl._bz': 'Moeda',
  '_txjl._je': 'Valor',
  '_txjl._dz': 'Endereço',
  '_txjl._zt': 'Status',
  '_txjl._sj': 'Tempo',
  '_txjl._cz': 'Ação',
  '_txjl._zwjl': 'Nenhum registro de transação ainda',
  '_txjl._czsx': 'Redefinir filtro',
  '_txjl._dny': 'Página {a} de {b}',
  '_txjl._jyxq': 'Detalhes da transação',
  '_txjl._skdz': 'Endereço de recebimento',
  '_txjl._jysj': 'Hora da transação',
  '_txjl._jyzt': 'Status da transação',
  '_txjl._fzdz': 'Endereço copiado para a área de transferência',

  '_cbsq._bz': 'Moeda',
  '_cbsq._wl': 'Rede',
  '_cbsq._erwm': 'Código QR',
  '_cbsq._fzdz': 'Copiar endereço',

  '_txsq._bz': 'Moeda',
  '_txsq._wl': 'Rede',
  '_txsq._ye': 'Saldo',
  '_txsq._sxf': 'Taxa',
  '_txsq._zxtx': 'Saque mínimo',
  '_txsq._txdz': 'Endereço de saque',
  '_txsq._qxztxdz': 'Por favor selecione o endereço de saque',
  '_txsq._txje': 'Valor do saque',
  '_txsq._qsrtxje': 'Por favor insira o valor do saque',
  '_txsq._yxyzm': 'Código de verificação de email',
  '_txsq._qsryxyzm': 'Por favor insira o código de verificação',
  '_txsq._ljtx': 'Sacar agora',

  '_jl._wxhd': 'Meus favoritos',
  '_jl._lsjl': 'Histórico',

  '_xx._bt': 'Central de mensagens',
  '_xx._wjl': 'Nenhum registro',
  '_xx._zsmyxx': 'Nenhuma mensagem ainda',
  '_xx._sxxx': 'Atualizar mensagens',
  '_xx._sxcg': 'Atualizado com sucesso',

  '_fx._fxhy': 'Compartilhar com amigos',
  '_fx._smfx': 'Escanear código QR para compartilhar com amigos',
  '_fx._jlsm': 'Descrição da recompensa',
  '_fx._jlsm1': '1. Amigos que você convida diretamente (Nível 1) concedem {a}% de seus ganhos.',
  '_fx._jlsm2': '2. Amigos convidados por seus amigos de Nível 1 (Nível 2) concedem {a}% de seus ganhos.',
  '_fx._jlsm3': '3. Amigos convidados por seus amigos de Nível 2 (Nível 3) concedem {a}% de seus ganhos.',
  '_fx._fzlj': 'Copiar link',

  '_bzzx._bzzx': 'Central de ajuda',
  '_bzzx._rhzczh': 'Como criar uma conta',
  '_bzzx._zclc': 'Processo de registro',
  '_bzzx._rhzcxyh': 'Como registrar uma nova conta?',
  '_bzzx._rhzcxyh1': 'Clique em "Registrar", insira seu email, defina uma senha e complete a verificação de email.',
  '_bzzx._rhcz': 'Como recarregar?',
  '_bzzx._rhcz1': 'Processo de recarga',
  '_bzzx._rhcz2': 'Instruções detalhadas de recarga',
  '_bzzx._rhcz3': 'Clique em Minha Carteira, Depositar, selecione a criptomoeda e envie para o endereço fornecido.',

  '_bzzx._rhjsdj': 'Como desbloquear dramas curtos',
  '_bzzx._rhjsdj2': 'Clique para desbloquear episódios individuais.',

  '_bzzx._rhtx': 'Como sacar da conta',
  '_bzzx._rhtx1': '1. Vá para Minha Carteira, Endereços de saque, adicione um novo endereço.<br>2. Clique em Sacar, selecione a moeda, insira o valor e aguarde.',

  '_bzzx._qtwt': 'Outras questões',
  '_bzzx._qtwt1': 'Como entrar em contato com o suporte?',
  '_bzzx._qtwt2': 'Contate-nos via chat online, email ou telefone.',
  '_bzzx._myzdwt': 'Não encontrou o que procurava?',
  '_bzzx._khjybbzn': 'Nossa equipe terá prazer em ajudar.',
  '_bzzx._lxkf': 'Contatar suporte',

  '_ggtf._bt1': 'Colocação de anúncios',
  '_ggtf._splb': 'Lista de vídeos',
  '_ggtf._wcyd': 'Minha participação',
  '_ggtf._hdbm': 'Código do evento',
  '_ggtf._tian': 'Dias',
  '_ggtf._kssj': 'Hora de início',
  '_ggtf._jssj': 'Hora de término',
  '_ggtf._ddvp': 'Alcance o nível VIP {a}, média de {b} participações por pessoa',
  '_ggtf._hdzt': 'Status do evento',
  '_ggtf._wks': 'Não iniciado',
  '_ggtf._ycy': 'Participado',
  '_ggtf._qg': 'Comprar agora',
  '_ggtf._mygdl': 'Sem mais dados',
  '_ggtf._qgrtd': 'Muitos compradores, tente novamente',
  '_ggtf._hdxq': 'Detalhes do evento',
  '_ggtf._hdjs': 'Descrição do evento',
  '_ggtf._cyyq': 'Requisitos de participação',
  '_ggtf._zdtz': 'Investimento mínimo',
  '_ggtf._vpdj': 'Nível VIP',
  '_ggtf._rjcy': 'Participação média',
  '_ggtf._gmje': 'Valor da compra',
  '_ggtf._qsrgmje': 'Por favor insira o valor da compra',
  '_ggtf._qx': 'Cancelar',
  '_ggtf._ljcy': 'Participar agora',
  '_ggtf._ssjymm': 'Insira a senha de transação',
  '_ggtf._qssjymm': 'Por favor insira a senha de transação',
  '_ggtf._ji': 'Nível',
  '_ggtf._ci': 'vezes',
  '_ggtf._zdgm': 'Valor mínimo de compra',
  '_ggtf._zggm': 'Valor máximo de compra',
  '_ggtf._zfz': 'Processando pagamento...',

  '_wdtg._wjl': 'Nenhum registro de participação ainda',
  '_wdtg._tzje': 'Valor investido',
  '_wdtg._zsy': 'Ganhos totais',
  '_wdtg._hdts': 'Duração do evento',
  '_wdtg._cysj': 'Hora de participação',
  '_wdtg._qzf': 'Ir para pagamento',
  '_wdtg._jxz': 'Em andamento',
  '_wdtg._djszje': 'Valor total pendente',
  '_wdtg._gjb': 'Total de {a} itens',
  '_wdtg._djs': 'Pendente',
  '_wdtg._zrsy': 'Ganhos de ontem',
  '_wdtg._dbl': 'Visualizações sob demanda',
  '_wdtg._bfl': 'Contagem de reproduções',
  '_wdtg._wdsy': 'Meus ganhos',
  '_wdtg._bqffc': 'Participação do detentor de direitos autorais',
  '_wdtg._mr0djs': 'Ganhos de ontem liquidados diariamente às 00:00',
  '_wdtg._jrsy': 'Ganhos de hoje',
  '_wdtg._mygd': 'Sem mais dados',

  '_bqyy._bqyy': 'Agendamento de cooperação de direitos autorais',
  '_bqyy._qrbq': 'Confirmar agendamento de cooperação?',
  '_bqyy._qx': 'Cancelar',
  '_bqyy._tjyy': 'Submeter agendamento',

  '_bqyy._spsq': 'Solicitação de cooperação em direitos autorais de vídeo',
  '_bqyy._spsy': 'Promova vídeos em conjunto para mais tráfego e ganhos!',
  '_bqyy._ljyy': 'Agendar agora',
  '_bqyy._sphz': 'O que é cooperação em direitos autorais de vídeo?',
  '_bqyy._sphzsm': 'A cooperação oferece mais visibilidade para benefício mútuo.',
  '_bqyy._sqhch': 'Benefícios da cooperação',
  '_bqyy._llfz': 'Suporte de tráfego',
  '_bqyy._llfzsm': 'Aumente a visibilidade e reproduções.',
  '_bqyy._sytg': 'Ganhos aumentados',
  '_bqyy._sytgsm': 'Obtenha maiores receitas publicitárias.',
  '_bqyy._yxhz': 'Cooperação prioritária',
  '_bqyy._yxhzsm': 'Participe prioritariamente em eventos oficiais.',
  '_bqyy._yytj': 'Condições de agendamento',
  '_bqyy._sptg': 'Requisitos de promoção de vídeo',
  '_bqyy._sptgsm': 'Participe em pelo menos 1 promoção de vídeo.',
  '_bqyy._yysm': 'Nossa equipe entrará em contato em 3 dias úteis.',

  '_ybp._wdsy': 'Meus ganhos',
  '_ybp._dqye': 'Saldo atual',
  '_ybp._jr': 'Hoje',
  '_ybp._jrzsy': 'Ganhos totais hoje',
  '_ybp._ljzsy': 'Ganhos totais acumulados',
  '_ybp._tgfh': 'Dividendos de promoção',
  '_ybp._ljsy': 'Ganhos acumulados',
  '_ybp._bqsy': 'Ganhos de direitos autorais',
  '_ybp._yqfh': 'Dividendos de indicação',
  '_ybp._mrsy': 'Ganhos diários',
  '_ybp._tgsy': 'Ganhos de promoção',

  '_tjdz._tjxd': 'Adicionar novo endereço',
  '_tjdz._xzbz': 'Selecionar moeda',
  '_tjdz._qbdz': 'Endereço da carteira',
  '_tjdz._srdz': 'Por favor insira o endereço da carteira',
  '_tjdz._qx': 'Cancelar',
  '_tjdz._bc': 'Salvar',

  '_sz._smrz': 'Verificação de identidade',
  '_sz._rzlx': 'Tipo de verificação',
  '_sz._sfzzm': 'Frente do documento de identidade',
  '_sz._sfzfm': 'Verso do documento de identidade',
  '_sz._zsxm': 'Nome real',
  '_sz._qsrzsxm': 'Por favor insira seu nome real',
  '_sz._sfzhm': 'Número do documento de identidade',
  '_sz._qsrsfzhm': 'Por favor insira o número do documento',
  '_sz._yyzz': 'Licença comercial',
  '_sz._qymc': 'Nome da empresa',
  '_sz._yyzzh': 'Número da licença comercial',
  '_sz._qsrqymc': 'Por favor insira o nome da empresa',
  '_sz._qsryyzzh': 'Por favor insira o número da licença',
  '_sz._qx': 'Cancelar',
  '_sz._tjrz': 'Submeter verificação',
  '_sz._zt': 'Status',
  '_sz._gr': 'Individual',
  '_sz._qy': 'Empresa',
  '_sz._shz': 'Em revisão',
  '_sz._ytg': 'Aprovado',
  '_sz._ybh': 'Rejeitado',

  '_mm._xgmm': 'Alterar senha',
  '_mm._dqxg': 'Altere a senha regularmente para segurança',
  '_mm._dqmm': 'Senha atual',
  '_mm._xmm': 'Nova senha',
  '_mm._qrxmm': 'Confirmar nova senha',
  '_mm._qx': 'Cancelar',
  '_mm._qrxg': 'Confirmar alteração',

  '_jymm._xgjymm': 'Alterar senha de transação',

  '_szzx._sz': 'Configurações',
  '_szzx._yrz': 'Verificado',
  '_szzx._wrz': 'Não verificado',
  '_szzx._jymm': 'Senha de transação',
  '_szzx._szjymm': 'Definir ou alterar senha de transação',
  '_szzx._tcdl': 'Sair',
  '_szzx._qdtcdl': 'Tem certeza que deseja sair?',
  '_szzx._qrtc': 'Confirmar saída',
  '_szzx._qx': 'Cancelar',

  '_yj._gy': 'Sobre nós',

  '_yj._lxwm': 'Fale conosco',

  '_yj._yszc': 'Política de Privacidade',

  '_yj._yhxy': 'Contrato do Usuário',

  '_cd._gszz': 'Qualificações da Empresa',

  '_cd._wmyy': 'Possuímos todas as qualificações e certificações necessárias para oferecer aos usuários serviços de vídeo legais, seguros e de alta qualidade',

  '_cd._yyzz': 'Comprovante válido da operação legal da empresa, demonstrando nossas informações de registro formal e escopo de negócios',

  '_cd._yyzz2': 'Licença comercial legalmente emitida pela empresa, garantindo a legalidade e a conformidade da plataforma',

  '_bz._lxkf': 'Clique abaixo para entrar em contato com o atendimento ao cliente ou entre em contato conosco por e-mail ou telefone',

  '_sz._bjtx': 'Editar',

  '_sz._bjxx': 'Editar mensagem',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Salvar',

  '_db._zskf': 'Fale com o Suporte',
  '_db._zsry': 'Atendente Dedicado',
  '_db._wdq': 'Não lido',
  '_db._ydq': 'Lido',

  '_sc._sctp': 'Carregar imagem',
  '_sc._xztp': 'Escolher imagem',
  '_sc._fstp': 'Enviar imagem',
  '_sc._qx': 'Cancelar',
  '_sc._hd': 'Ok',

  '_zcyl._zcbt': 'Presente de cadastro',
  '_zcyl._djdkhb': 'Toque para abrir o envelope vermelho',
  '_zcyl._zclj': 'Bônus de registro',
  '_zcyl._hmyzh': 'Ainda não tem conta?',
  '_zcyl._qzc': 'Cadastrar',
  '_zcyl._qxdjhb': 'Resgate seu prêmio primeiro',
  '_zcyl._qwzc': 'Ir para cadastro',
  '_zcyl._hbysy': 'Prêmio já utilizado',

  '_ggtg._qhz': 'Ir para Transferência',
  '_ggtg._dqye': 'Saldo Atual',
  '_ggtg._qcz': 'Ir para Depósito',
  '_ggtg._hzje': 'Valor da Transferência',
  '_ggtg._ljhz': 'Transferir Agora',
  '_ggtg._yebz': 'Saldo Insuficiente',

  '_sq._bhbt': 'Rejeitado',

  '_sq._bhyy': 'Motivo da rejeição',

  '_xx._ntq': 'Há n dias',

  '_xx._nxsq': 'Há n horas',

  '_xx._nfzq': 'Há n minutos',

  '_xx._nggq': 'Agora mesmo',

  '_xx._djckgd': 'Clique para ver mais',

  '_ct._zt': 'Status',

  '_ct._ljz': 'Conectando',

  '_ct._ylj': 'Conectado',

  '_ct._ltlieb': 'Lista de bate-papo',

  '_ct._bnhzj': 'Não consigo conversar comigo',

  '_ct._cylb': 'Lista de membros',

  '_hb._fhb': 'Envelope vermelho',

  '_hb._dqye': 'Saldo atual',

  '_hb._fsd': 'Enviado para',

  '_hb._hbje': 'Valor do envelope vermelho',

  '_hb._qshuru': 'Por favor, insira o valor do envelope vermelho',

  '_hb._ljfs': 'Enviar agora',

  '_hb._hbz': "Envelope vermelho' Bênção",
  '_hb._qshuruzhu': 'Por favor, insira sua bênção',

  '_sp._cuow': 'Os episódios 1 a 10 precisam ser desbloqueados antes de você poder assisti-los',

  '_bq._tzzq': 'Período de Investimento',

  '_bq._zrsy': 'Lucro de Ontem',

  '_bq._bqtz': 'Investimento em Direitos Autorais',

  '_bq._tzdj': 'Valor do Investimento',

  '_bq._zfjz': 'O pagamento deve ser efetuado em até 24 horas, caso contrário, será considerado desistência!',

  '_bq._qzf': 'Efetuar Pagamento',

  '_bq.jz': 'Prazo Final',

  '_bq._ljzf': 'Pagar Agora',

  '_bq._sqbz': 'Observações sobre a Aplicação (Opcional)',

  '_bq._sqbzsm': 'Por favor, insira as observações sobre a aplicação',

  '_bq._zzsqz': 'Aplicação de direitos autorais em Progresso, aguardando revisão...',

  '_app._xz': 'Baixe o aplicativo ReelShortBiz',

  '_app._smerm': 'Escaneie o código QR para baixar',

  '_app._xzbt': 'Baixar',

  '_m._yhzz': 'Transferência bancária',
  '_m._yhxx': 'Informações bancárias',
  '_m._yhmz': 'Nome do banco',
  '_m._yhdz': 'Endereço do banco',
  '_m._yhmc': 'Nome',
  '_m._yhzh': 'Conta',
  '_m._yhlx': 'Tipo',
  '_m._yhly': 'Roteamento',
  '_m._yhdm': 'Código',
  '_m._yhbz': 'Nota',
  '_m._fzxx': 'Copiar informações',

  '_m._zts': 'Dicas',

  '_m._zyd1': '1. Verifique cuidadosamente o nome do destinatário, o número da conta e o código do banco ao transferir fundos. Qualquer erro pode resultar na perda da remessa.',

  '_m._zyd2': "2. Recomenda-se selecionar 'O remetente arca com todas as taxas' para evitar fundos insuficientes devido a deduções do banco intermediário.",

  '_m._zyd3': '3. As transferências geralmente levam de 1 a 3 dias úteis. Seja paciente. Em caso de dúvidas, entre em contato com o atendimento ao cliente.',

  '_m._zyd4': '4. Em caso de outras dúvidas, entre em contato com o atendimento ao cliente.',

  '_m._jyh': 'Número da Transação',

  '_m._jyje': 'Valor',

  '_sp._dbye': 'Saldo VOD',
  '_sp.hzye': 'Transferência',
  '_sp._txje': 'Valor da Transferência',
  '_sp._qsrtxje': 'Digite o valor da transferência',
  '_sp._ljhz': 'Transferir Agora',
  '_sp._yebz': 'Saldo insuficiente',
  '_sp._qshuru': 'Digite o valor correto da transferência',
  '_sp._fanh': 'Voltar',

  '_sp._tliu': 'Publicidade',
  '_sp._xzgj': 'Selecionar país',
  '_sp._cdcw': 'Erro de codificação de vídeo',
  '_ggtf._hot': 'Popular',
  '_tl._tlsj': 'Horário de publicidade',
  '_tl._xzxb': 'Selecionar gênero',
  '_tl._nan': 'Masculino',
  '_tl._nv': 'Feminino',
  '_tl._hunhe': 'Misto',
  '_tl._xznl': 'Selecionar idade',
  '_sp._us': 'Estados Unidos',
  '_sp._en': 'Reino Unido',
  '_sp._jp': 'Japão',
  '_sp._fr': 'França',
  '_sp._kr': 'Coreia do Sul',
  '_sp._de': 'Alemanha',
  '_sp._id': 'Índia',
  '_sp._in': 'Indonésia',
  '_sp._au': 'Austrália',
  '_sp._es': 'Espanha',
  '_sp._my': 'Malásia',
  '_sp._cn': 'China',
  '_ggtf._fanhui': 'Voltar',
  '_ggtf._jymmts': 'Confirme o valor da transação e insira sua senha',
  '_wdtg._wjl_desc': 'Você ainda não participou de nenhuma campanha publicitária',
  '_wd._jxz': 'Em andamento',
  '_wd._djs': 'Aguardando liquidação',
  '_wd._ywc': 'Concluído',
  '_wd._jz': 'Urgente',
  '_wd._hz': 'Transferência',

  '_tl._tlfbqk': 'Distribuição dos gastos com anúncios',
  '_tl._tlfbqk_desc': 'Dias 1-5: 5% (Fase de inicialização a frio), Dias 6-10: 20% (Fase de validação de conteúdo), Dias 11-15: 40% (Fase de construção de IP), Dias 16-20: 35% (Fase de matriz de minisséries)',

  '_nhz._sm': 'Após a transferência, o valor será transferido para a carteira de vídeo para desbloquear conteúdo de vídeo',
  '_nhz._zhzz': 'Transferindo...',
  '_nhz._zzcg': 'Transferência bem-sucedida',
  '_nhz._zhzsb': 'Falha na transferência, tente novamente',
  '_m._fzcg': 'Copiado com sucesso',
  '_m._fzsb': 'Falha ao copiar, copie manualmente',
  '_m._zwfzxx': 'Nenhuma informação para copiar',
  '_tx._qb': 'Todos',
  'activity.detail': 'Detalhes da Atividade',
  'activity.noDesc': 'Sem descrição da atividade',
  'activity.desc': 'Descrição da Atividade',
  'activity.requirements': 'Requisitos de Participação',
  'activity.minInvest': 'Investimento Mínimo',
  'activity.vipLevel': 'Nível VIP',
  'activity.avgParticipation': 'Participação Média',
  'activity.avgParticipationDesc': 'vezes',
  'activity.country': 'Selecionar País',
  'activity.deliveryTime': 'Tempo de Publicidade',
  'activity.deliveryTimeDesc': 'dias',
  'activity.gender': 'Selecionar Gênero',
  'activity.male': 'Masculino',
  'activity.female': 'Feminino',
  'activity.mixed': 'Misto',
  'activity.age': 'Selecionar Idade',
  'activity.amount': 'Valor da Compra',
  'activity.back': 'Voltar',
  'activity.join': 'Participar Agora',
  emptyData: 'Sem Dados',
  emptyDataDesc: 'Nenhuma campanha publicitária participante',
  completedtlement: 'Expirado',
  preheat: 'Pré-aquecendo',
  progress: 'Em Andamento',
  settlement: 'Aguardando Liquidação',
  transfered: 'Transferido',
  completed: 'Concluído',
  activityCode: 'Código da Atividade',
  touzAmount: 'Valor do Investimento',
  activityDays: 'Dias de Atividade',
  joinTime: 'Hora de Participação',
  playSource: 'Distribuição de Fontes de Reprodução',
  allPlatforms: 'Todas as Plataformas',
  other: 'Outro',
  totalPlayNum: 'Total de Reproduções',
  incomeSummary: 'Resumo de Receitas',
  totalPay: 'Taxas de Direitos Autorais Pagas',
  totalIncome: 'Receita Total',
  copyrightRatio: 'Participação do Titular dos Direitos',
  promotionIncome: 'Receita de Promoção',
  copyrightIncome: 'Participação de Direitos Autorais',
  playNum: 'Reproduções',
  buyNum: 'Reproduções sob Demanda',
  incomeRate: 'Proporção de Participação',
  yjIncome: 'Receita Estimada',
  paid: 'Pago',
  timeout: 'Tempo Esgotado',
  transfer: 'Transferir Agora',
  loading: 'Carregando...',
  loadMore: 'Carregar Mais',
  noMore: 'Não Há Mais',
  nightTime: 'Período Noturno',
  morningTime: 'Período Matutino',
  afternoonTime: 'Período Vespertino',
  eveningTime: 'Período Noturno',
  '_h._tc': 'Sair',
  periodPayment: 'Pagamento por Período',
  periodPaymentDesc: 'A liquidação ocorre 4 vezes ao dia em 4 períodos, você pode pagar as taxas de direitos autorais por período',

  day: 'dia',
  '_dl._hy': 'Bem-vindo de volta',
  '_dl._cj': 'Criar conta',
  '_dl._zmm': 'Redefinir senha',
  '_dl._hyDesc': 'Faça login na sua conta para continuar explorando conteúdo excelente',
  '_dl._cjDesc': 'Junte-se ao ReelShortBiz e comece sua jornada emocionante',
  '_dl._zmmDesc': 'Digite seu email e enviaremos um código de verificação para redefinir',
  '_dl._hlgqsp': 'Amplos recursos de filmes e vídeos em HD',
  '_dl._gxhty': 'Algoritmos de recomendação personalizados',
  '_dl._ffddsp': 'Vídeos curtos variados',
  '_dl._dlzh': 'Entrar',
  '_dl._sdndyx': 'Digite seu email e senha para continuar',
  '_dl._email': 'Endereço de email',
  '_dl._qsryx': 'Por favor, digite seu endereço de email',
  '_dl._dlmm': 'Senha',
  '_dl._qsrmm': 'Por favor, digite sua senha',
  '_dl._wjmm': 'Esqueceu a senha?',
  '_dl._immdl': 'Entrar agora',
  '_dl._hmyzh2': 'Não tem uma conta?',
  '_dl._ljzc2': 'Registre-se agora',
  '_dl._cjzh': 'Criar conta',
  '_dl._jswmd': 'Junte-se ao ReelShortBiz e comece sua jornada emocionante',
  '_zh._qszmm': 'Por favor, defina sua senha',
  '_zh._qrmm': 'Confirmar senha',
  '_zh._qmm': 'Por favor, digite a senha novamente',
  '_zc._yqm': 'Código de convite',
  '_zc._sryqm': 'Por favor, digite o código de convite',
  '_dl._yzm': 'Código de verificação',
  '_dl._qsryzm': 'Por favor, digite o código de verificação',
  '_dl._yjyzh': 'Já tem uma conta?',
  '_dl._zcbsty2': 'Ao registrar-se, você concorda com',
  '_dl._zcbstyDesc': 'Política de Privacidade',
  '_dl._newmm': 'Nova senha',
  '_dl._qszxmm': 'Por favor, defina uma nova senha',
  '_dl._qrmm': 'Confirmar senha',
  '_dl._qzcsrmm': 'Por favor, digite a nova senha novamente',
  '_dl._czmm': 'Redefinir senha',
  '_dl._xqlmm': 'Lembrou da sua senha?',
  '_dl._fhdl': 'Voltar ao login',
  '_dl._srdllmmbyz': 'As senhas não coincidem',
  '_dl._czcg': 'Senha redefinida com sucesso',
  '_h._zc': 'Registrar',
  // '_ybp._wdsy': 'Meus ganhos',
  '_ybp._jrsy': 'Ganhos de hoje',
  '_ybp._jztr': 'Comparado a ontem',
  '_ybp._bfl': 'Visualizações',
  '_ybp._dbl': 'Solicitações',
  '_ybp._syqs': 'Tendência de ganhos',
  // '_ybp._jr': 'Hoje',
  '_ybp._t': 'dia',
  // '_ybp._dqye': 'Saldo da conta',
  '_ybp._djs': 'Pendente de liquidação',
  '_ybp._zhl': 'Taxa de conversão',
  '_ybp._sjgl': 'Visão geral dos dados',
  '_ybp._zrsy': 'Ganhos de ontem',
  '_ybp._bysy': 'Ganhos deste mês',
  '_ybp._yysj': 'Dados operacionais',
  '_ybp._zr': 'Ontem',
  '_ybp._zjfrs': 'Total de usuários pagantes',
  '_ybp._mtdqje': 'Valor a receber amanhã',
  '_ybp._jsy': 'Ganhos líquidos',
  '_ybp._bqfy': 'Plano de pagamento de direitos autorais',
  '_ybp._yzf': 'Pago',
  '_ybp._qzf': 'Ir para pagar',
  '_ybp._bqfyts': 'Após o pagamento dos direitos autorais, seus ganhos e direitos serão priorizados',
  '_ybp._syjl': 'Histórico de ganhos',
  '_ybp._ckgd': 'Ver mais',
  '_ybp._ssdt': 'Atualizações ao vivo',
  '_ybp._bzzx': 'Central de Ajuda',
  '_ybp._lxkf': 'Contatar suporte',
  '_ybp._zrxz': 'Ganhos de ontem',
  '_ybp._zdsy': 'Ganhos totais',
  '_ybp._qygy': 'Mês passado',
  '_ybp._jsjl': 'Histórico de liquidações',
  '_ybp._hzjl': 'Histórico de transferências',
  '_ybp._jfzq': 'minutos atrás',
  '_ybp._fzq': 'horas atrás',
  '_ybp._djs_mt': 'Valor de liquidação amanhã',
  '_yj._rule': 'Regras da plataforma',

  '_bq._jjks': 'Começar agora',
  '_bq._jxz': 'Em curso',
  '_bq._jks': 'Tempo para começar',
  '_bq._jjs': 'Tempo para terminar',
  '_bq._t': 'd',
  '_bq._h': 'h',
  '_bq._m': 'min',
  '_bq._s': 's',
  '_bq._kssj': 'Hora de início',
  '_bq._jssj': 'Hora de fim',
  '_bqq._tzdj': 'Preço unitário',
  '_bqq._hdts': 'Dias de evento',
  '_bqq._vip': 'Nível VIP',
  '_bqq._rjcy': 'Participação média',
  '_bqq._cs': 'vezes',
  '_bqq._ysjd': 'Progresso de vendas',
  '_bqq._ljqg': 'Comprar agora',
  '_bqq._zbkqg': 'Atualmente indisponível',
  '_bqq._jzz': 'A carregar',
  '_bqq._jzgd': 'Carregar mais',
  '_bqq._wz': 'Sem mais itens',

  '_sp._gdsj': 'Total {n} episódios',
  '_sy._jl': 'Registo de liquidação pendente',
  '_ybp._zsy': 'Receita total',
  '_ybp._djsjl': 'Registo de liquidação pendente',
  '_ybp._bqbm': 'Código',
  '_ybp._je': 'Valor',
  '_ybp._sj': 'Hora',
  '_sy._djs': 'Pendente',
  '_sy._yjs': 'Liquidado',
  '_sy._gdstjl': 'Total {n} registos',
  '_sy._gjd': 'Total {n}',

  '_sp.tgdy':'O valor não pode ser inferior a {a}',
  '_sp.tggy':'O valor não pode ser superior a {a}',

  '_tg._zdyje': 'Valor personalizado'
}
